import React, { Component } from 'react';
import * as Request from '../service/data-info-chart/requestsUtil';
import { BUSINESS_UNIT, CLAIMS, EDIT_CLAIMS, } from '../utils/constants';
import TotalClaims from '../charts/totalClaims';
import SaveModal from './buttons/saveModal';
import VieModal from './buttons/viewModal';

class MonthlyClaims extends Component {

  callback = (dataFromChild) => {
    this.setState({
      data: dataFromChild,
    });
  };
  callback2 = (dataFromChild) => {
    this.setState({
      key: dataFromChild,
    });
  };

  constructor(props) {
    super(props);
    this.callback = this.callback.bind(this);
    this.state = {
      modal: false,
      places: [],
      data: [],
      text: '',
      claims: '',
      key: 0,
    };
  }

  componentDidMount() {
    Request.getFetch(BUSINESS_UNIT)
      .then((data) => {
        this.setState({
          places: data,
          loaded: true,
          key: Math.random() * 11,
        });
      });
  }

  render() {

    let results = '';
    if (this.state.data.claimsPls !== undefined) {
      if (this.state.places !== []) {
        results = this.state.places.map((place, index) => {
          if (this.state.data.claimsPls[index] !== undefined) {

            //Este if oculta las plazas de Culiacan y Vallarta
            if (place.id !== 1 && place.id !== 2) {

              return <div className='mr-xl-5 mr-0 pb-md-0 pb-5'>
                <div className="product-single-claims d-flex justify-content-start mb-5 ">
                  <div className='center-class'>
                    <img id={place.name} src={place.image} alt=" "
                         className="img-places-claims imgStyleClaims"/>
                  </div>
                  <div className='flex-column'>
                    <div key={this.state.key} className='title-bu'>
                      {this.state.data.claimsPls[index].numberClaims} Reclamaciones
                    </div>
                    <p className='p-bu'>Unidad {place.name}</p>
                  </div>
                  <div className='icons-normals d-inline-flex ml-lg-5 ml-2'>
                    <VieModal url={CLAIMS + place.id + '/' + this.props.date} place={place}
                              dateModal={this.props.dateModal}/>
                  </div>
                  <div className='save-modal'>
                    <SaveModal date={this.props.date} place={place} url={EDIT_CLAIMS}
                               dateModal={this.props.dateModal}
                               authorization={this.props.authorization}
                               callbackFromParent={this.callback2}/>
                  </div>
                </div>
              </div>;

            }
          }
        });
      }
    }

    return (
      <div>
        <div className='container-fluid back-color-grey'>
          <div className='row'>
            <div className='container-fluid quality-title-1'>
              Reclamaciones mensuales
            </div>
          </div>
        </div>
        <div className='container-fluid back-color-grey'>
          <div className='row'>
            <div className='col-lg-6 col-12 p-2 mb-5' style={{ width: '90%' }}>
              <div className='mb-5'>
                <div className='back-color-white' key={this.state.key}>
                  <TotalClaims key={this.state.key} date={this.props.date}
                               callbackFromParent={this.callback}/>
                </div>
              </div>
            </div>
            <div className='col-lg-6 p-2 back-color-grey box-place'>
              {results}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default MonthlyClaims;



// WEBPACK FOOTER //
// ./src/components/monthlyClaims.js